module.exports = __webpack_public_path__ + "static/media/p.43752979.gif";